import { ApiEmployment } from '../api-types/employment.api';
import { Employment } from '../app-types/employment.app';

/**
 * Transforms an API Employment object to an App Employment object.
 * @param input The API Employment object to transform.
 * @returns The transformed App Employment object.
 */
export function transformApiEmploymentToAppEmployment(input: ApiEmployment): Employment {
	return {
		id: input.id,
		maximumOverAllPositionShare: input.maximumOverAllPositionShare,
		remark: input.remark,
		serviceId: input.serviceId,
	};
}

/**
 * Transforms an array of API Employment objects to an array of App Employment objects.
 * @param inputs The array of API Employment objects to transform.
 * @returns The array of transformed App Employment objects.
 */
export function transformApiEmploymentsToAppEmployments(inputs: ApiEmployment[]): Employment[] {
	return inputs.map(transformApiEmploymentToAppEmployment);
}
